import type { ReactNode } from "react";
import { useEffect } from "react";


declare global {
    interface Window {
        themoneytizer_async?: number;
    }
}


/**
 * The Moneytizer's ad scripts are ... crap.
 */
function cleanupScriptFallout() {
    window.themoneytizer_async = undefined;
}


interface AdBannerProps {
    className?: string;
    children?: ReactNode;
    siteID: string;
    formatID: string;
}


export function AdBanner({ className, children, siteID, formatID }: AdBannerProps) {
    const adUnitID = `${siteID}-${formatID}`;
    const genScriptID = `gen-${adUnitID}`;
    const requestScriptID = `request-${adUnitID}`;

    useEffect(() => {
        const container = document.getElementById(adUnitID);
        if (!container) {
            console.error("Unable to find ad container");
            return;
        }

        cleanupScriptFallout();
        const genScript = document.createElement("script");
        genScript.id = genScriptID;
        genScript.src = `//ads.themoneytizer.com/s/gen.js?type=${formatID}`;
        genScript.async = true;
        container.appendChild(genScript);

        const requestScript = document.createElement("script");
        requestScript.id = requestScriptID;
        requestScript.src = `//ads.themoneytizer.com/s/requestform.js?siteId=${siteID}&formatId=${formatID}`;
        requestScript.async = true;

        // Delay seems to help with weird double-placement issue.
        const requestPlacer = setTimeout(() => {
            container.appendChild(requestScript);
        }, 250);

        return () => {
            // Cleanup scripts on component unmount
            if (container.contains(genScript)) {
                container.removeChild(genScript);
            }
            clearTimeout(requestPlacer);
            if (container.contains(requestScript)) {
                container.removeChild(requestScript);
            }
            cleanupScriptFallout();
        };
    }, [siteID, formatID, adUnitID, genScriptID, requestScriptID]);
    return (
        <div className={className}>
            <div id={adUnitID}></div>
            {children}
        </div>
    );
}
